(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-shared/withdrawal-info.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-shared/withdrawal-info.js');
"use strict";


const Icon = svs.ui.ReactIcon;
const WithdrawalInfo = () => React.createElement("div", {
  className: "bg-tur-100 u-flex-justify-content-center align-center margin-v-2 u-border-radius-12"
}, React.createElement("div", {
  className: "withdrawal-info-container padding-1"
}, React.createElement(Icon, {
  className: "padding-bottom-1",
  icon: "withdrawal",
  size: "700"
}), React.createElement("p", {
  className: "align-left margin-0"
}, "Du kan alltid ta ut dina pengar fr\xE5n spelkontot n\xE4r du vill, utan avgift!")));
svs.accountservicesReact.deposit.depositShared.WithdrawalInfo = WithdrawalInfo;

 })(window);